/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:06:36
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-26 09:40:47
 */
// 配置
export const Configs = {
  // 元素连线颜色
  // edgeColor: '#008EFF',
  edgeColor: '#F73046'
}
